import { delay } from 'redux-saga';
import { call, all, put, select } from 'redux-saga/effects';

import { isMC } from 'src/utils/env';
import { setStorage, STORAGE } from 'src/tools/storage';
import { langs, DEFAULT_TIME } from '../assets/lang.json';
import { routeNames } from '../routes/router';
import * as globalApi from '../services/globalApi';
import * as staffApi from '../services/staffApi';

const initialState = {
  token: '',
  maskToken: '',
  langMap: langs,
  defaultTime: DEFAULT_TIME,
  locale: isMC() ? 'en' : 'chs', // 语言 chs
  // fixme: 后续等待登录后才可以注入数据
  loading: false,
  routeNames,
  attrAliasList: [],
  attrMap: {},
  attrList: [],
  dayOption: [],
  nameOption: [],
  staffList: [],
  userColorList: [],
  userInfo: {},
  staffInfo: {},
  cacheMenus: [], // 缓冲的menu(session)
  persistMenus: [], // 持久保存的菜单(local, 排序优先)
  reportList: [],
  reportError: null, // 报错
  fileInfo: {}, // 导入模版
  fileTemp: {},
  countryInfo: [], // MC关系导入，国家英文全拼/缩写列表
  configs: {}, // 用户的一些配置信息(导入客户预售单加的)
  backToken:'', // 从外界获取到的token
  backMaskToken:'', // 从外界获取到的maskToken
};

export const state = initialState;

export const effects = {
  *uploadImage({ payload }) {
    const response = yield call(globalApi.updateImage, payload);
    return response;
  },
  *syncAppData({ payload }) {
    yield put({ type: 'app/fetchLangFile' });
    yield put({ type: 'app/setState', payload: { loading: true } });
    const [userAttr, commissionAttr, userColor, user, admin, configs] = yield all(
      [
        call(globalApi.getUserAttr, {
          type: [
            'category',
            'brand',
            'year',
            'season',
            'wave',
            'client_cat1',
            'client_cat2',
            'client_cat3',
            'client_cat4',
          ],
        }),
        call(globalApi.getCommissionAttrById),
        call(globalApi.getUserColor),
        call(globalApi.getStartUp),
        call(staffApi.getAdminList),
        call(globalApi.getConfigs)
      ].filter(Boolean)
    );
    if (userAttr && commissionAttr && userColor && user && admin && configs) {
      // const staffId = user.user_info.staff_id;
      // const staff = yield call(globalApi.getStaff, { staff_id: staffId });
      const staff = yield call(globalApi.getStaff);
      yield put({
        type: 'app/setState',
        payload: {
          attrAliasList: userAttr.attr_alias,
          attrMap: userAttr.attr_map,
          attrList: userAttr.list,
          dayOption: commissionAttr.info.day_option,
          nameOption: commissionAttr.info.name_option,
          staffList: commissionAttr.info.staff_list,
          userColorList: userColor.list,
          userInfo: user.user_info,
          // staffInfo: staff ? staff.info : {},
          staffInfo:staff ? staff.data : {},
          accountList: admin.staff_list,
          configs: configs.result.setting,
          // 重新登录后清除 tab
          cacheMenus: [],
          persistMenus: [],
        },
      });
      if (!isMC() && user?.user_info?.show_report_entrance && !payload?.refuseReport) {
        yield call(delay, 1000);
        yield put({ type: 'app/fetchReportList' });
      }
    }
    // 导入模版表头
    const res = yield call(globalApi.requestImportFile);
    if (res && res.data) {
      yield put({ type: 'app/initFileInfo', payload: { data: res.data } });
    }
    // 国家列表
    if (isMC()) {
      yield put({ type: 'app/getCountryInfo' });
    }

    yield put({ type: 'app/setState', payload: { loading: false } });
  },
  // 多语言包增量更新
  *fetchLangFile() {
    const { langMap, defaultTime, locale } = yield select(({ appState }) => appState);
    // 1 获取 chs 的 key 做为所有keys值
    const LANG = langMap.chs || {};
    const keys = new Map();
    // 2 遍历所有 key，改为 key => [name]
    Object.keys(LANG).forEach((name) => {
      Object.keys(LANG[name]).forEach((key) => {
        const names = keys.get(key) || [];
        keys.set(key, [...names, name]);
      });
    });

    // 3 根据所支持的语言请求增量数据
    // 3.1 生成新的 utime
    const newTime = parseInt(Date.now() / 1000, 10);
    const res = yield call(globalApi.requestLangFile, {
      lang: locale,
      project: JSON.stringify([4]),
    });
    if (res && !Number(res.err || 0)) {
      const info = res?.info || {};

      // 更新增量数据
      const tLangs = langMap[locale] || {};
      Object.keys(info).forEach((k) => {
        (keys.get(k) || []).forEach((n) => {
          tLangs[n] = { ...tLangs[n], [k]: info[k] };
        });
      });
      const newLangMap = {...langMap, [locale]: {...tLangs}}
      // 更新内容
      yield put({
        type: 'app/setState',
        payload: {
          defaultTime: newTime,
          langMap: newLangMap
        },
      });
      setStorage(STORAGE.LOCALE.MAP, langMap[locale], false);
    }
  },
  // 获取报表列表
  *fetchReportList() {
    const res = yield call(globalApi.requestReports);
    if (Number(res?.code || 0) === 30010) {
      const { userInfo } = yield select(({ appState }) => appState);
      yield put({
        type: 'app/setState',
        payload: { userInfo: { ...userInfo, show_report_entrance: false } },
      });
    } else {
      const list = res?.reports?.data || [];

      yield put({
        type: 'app/setState',
        payload: { reportList: list, reportError: res },
      });
      yield put({ type: 'dailyReport/initState', payload: list });
    }
    return res;
  },
  // 获取数据
  *fetchTraceBox({ payload }) {
    const res = yield call(globalApi.requestTraceBox, payload);

    return JSON.parse(res?.list?.[payload.key] || null);
  },
  *fetchUpdateTraceBox({ payload }) {
    return yield call(globalApi.requestUpdateTraceBox, payload);
  },
  // 国家列表
  *getCountryInfo() {
    const { langMap } = yield select(({ appState }) => appState);
    let obj = {};
    let keys;
    for (const k of Object.keys(langMap)) {
      const res = yield call(globalApi.getCountryInfo, k);
      if (res) {
        if (!keys || !keys.length) {
          keys = Object.keys(res.info || {});
        }
        obj = Object.keys(res.info).reduce((acc, k) => ((acc[res.info[k]] = k), acc), obj);
      }
    }
    yield put({
      type: 'app/setState',
      payload: {
        countryInfo: [obj, ...keys, ...Object.keys(obj)],
      },
    });
  },
};

export const reducers = {
  addCacheMenus(state, { payload }) {
    const newMenu = payload.menu;
    const { cacheMenus, persistMenus } = state;
    const existMenus1 = cacheMenus.find((item) => item.path === newMenu.path);
    const existMenus2 = persistMenus.find((item) => item.path === newMenu.path);
    if (!existMenus1 && !existMenus2) {
      cacheMenus.push(newMenu);
    }
    return { ...state, cacheMenus: [...cacheMenus] };
  },
  affixMenu(state, { payload }) {
    const { menu } = payload;
    const { persistMenus, cacheMenus } = state;
    const menu1 = persistMenus.find((item) => item.path === menu.path);
    const index2 = cacheMenus.findIndex((item) => item.path === menu.path);
    if (!menu1 && index2 !== -1) {
      cacheMenus.splice(index2, 1);
      persistMenus.push(menu);
    }
    return { ...state, cacheMenus: [...cacheMenus], persistMenus: [...persistMenus] };
  },
  unAffixMenu(state, { payload }) {
    const { menu } = payload;
    const { persistMenus, cacheMenus } = state;
    const menu1 = cacheMenus.find((item) => item.path === menu.path);
    const index2 = persistMenus.findIndex((item) => item.path === menu.path);
    if (!menu1 && index2 !== -1) {
      persistMenus.splice(index2, 1);
      cacheMenus.push(menu);
    }
    return { ...state, cacheMenus: [...cacheMenus], persistMenus: [...persistMenus] };
  },
  removedMenu(state, { payload }) {
    const { cacheMenus, persistMenus } = state;
    const { menu } = payload;
    const index1 = cacheMenus.findIndex((item) => item.path === menu.path);
    if (index1 !== -1) {
      cacheMenus.splice(index1, 1);
    }
    const index2 = persistMenus.findIndex((item) => item.path === menu.path);
    if (index2 !== -1) {
      persistMenus.splice(index2, 1);
    }
    return { ...state, cacheMenus: [...cacheMenus], persistMenus: [...persistMenus] };
  },
  // 1 商品横排 2 商品竖排 3 商品货号模板 4 客户模板 5 供货商模板
  initFileInfo(state, { payload }) {
    const { data } = payload;
    const info = {};
    Object.keys(data || {}).forEach((lang, i) => {
      Object.keys(data[lang] || {}).forEach((temp, j) => {
        if (!info[temp]) {
          info[temp] = new Map();
        }
        const headers = data[lang][temp].headers || {};
        Object.keys(headers).forEach((key) => {
          info[temp].set(headers[key].name, { key, ...headers[key] });
        });
      });
    });
    const fileInfo = Object.keys(info).reduce(
      (acc, k) => ((acc[k] = [...info[k].entries()]), acc),
      {}
    );

    return { ...state, fileInfo, fileTemp: data };
  },
};
